import { commonRoutes } from '../../routes/commonRoutes';
export const jewelleryRoutes = commonRoutes;
